module.exports = __webpack_public_path__ + "media/images/logo_ofqj-12bd8afbcea6eb175a1b571b80c5b329.png";